<form id="catalog-form" *ngIf="form && catalogFields" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g">
    <div class="ui-g-9 ui-md-9 ui-lg-9">
      <h1 *ngIf="catalogId" class="step-title">{{ 'common.edit' | translate }} {{ 'catalog.catalog' | translate }}</h1>
      <h1 *ngIf="!catalogId" class="step-title">{{ 'common.add' | translate }} {{ 'catalog.catalog' | translate }}</h1>
    </div>
    <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/promotion/catalog" label="{{ 'common.back' | translate }}"></button>
      <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
    </div>
  </div>
  <div class="card">
    <div class="ui-g ui-fluid">
      <!-- Codice -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogFields.code.nullable}">{{ catalogFields.code.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="code" maxlength="15"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogFields.code"></app-validation-msg>
      </div>
      <!-- Descrizione -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogFields.description.nullable}">{{ catalogFields.description.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="description" maxlength="50"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogFields.description"></app-validation-msg>
      </div>
    </div>
    <div class="ui-g ui-fluid">
      <!-- Data Inizio -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogFields.dt_start.nullable}">{{ catalogFields.dt_start.keyName }}</span>
        <app-kv-calendar
          #dateStartField
          [inputName]="'dt_start'"
          [formData]="form"
          [startDateSelector]="true"
          [endDateInputName]="'dt_end'"
          [endDateCalendar]="dateEndField"
          [defaultDate]="f.dt_start.value"
          [defaultValue]="f.dt_start.value">
        </app-kv-calendar>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogFields.dt_start"></app-validation-msg>
      </div>
      <!-- Data Fine -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogFields.dt_end.nullable}">{{ catalogFields.dt_end.keyName }}</span>
        <app-kv-calendar
          #dateEndField
          [inputName]="'dt_end'"
          [formData]="form"
          [endDateSelector]="true"
          [startDateInputName]="'dt_start'"
          [startDateCalendar]="dateStartField"
          [defaultDate]="f.dt_end.value"
          [defaultValue]="f.dt_end.value">
        </app-kv-calendar>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogFields.dt_end"></app-validation-msg>
      </div>
    </div>
    <div class="ui-g ui-fluid">
      <!-- Barcode con Contributo -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogFields.barcode_cont_pickup.nullable}">{{ catalogFields.barcode_cont_pickup.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="barcode_cont_pickup" maxlength="14"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogFields.barcode_cont_pickup"></app-validation-msg>
      </div>
      <!-- Barcode solo Punti -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" [ngClass]="{'required': !catalogFields.barcode_nocont_pickup.nullable}">{{ catalogFields.barcode_nocont_pickup.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="barcode_nocont_pickup" maxlength="14"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="catalogFields.barcode_nocont_pickup"></app-validation-msg>
      </div>
    </div>

    <div class="ui-g ui-fluid">
      <!-- Descrizione Lunga -->
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ catalogFields.long_descr.keyName }}</span>
        <p-editor type="html" class="fieldInput" formControlName="long_descr" ></p-editor>
      </div>
       <!--Catalog Url -->
      <div class="ui-g-12 ui-md-4">
        <span class="label" >{{ catalogFields.catalog_url.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="catalog_url" maxlength="200"/>
      </div>
    </div>
    <!-- Aggiungi Divisione Rete Vendita -->
    <div class="ui-g">
      <div class="ui-g-11 ui-md-11 ui-lg-11">
        <h3 class="title">{{ 'catalog.divisionsSalesNetwork' | translate }}</h3>
      </div>
      <div class="ui-g-12 ui-md-12 ">
        <button pButton (click)="addSalesNetworkDivision()" icon="fa fa-plus-circle" iconPos="right" type="button" class="k-generic-btn" label="{{ 'common.add' | translate }}"></button>
      </div>
    </div>
    <!-- Divisioni Rete di Vendita -->
    <div formArrayName="salesNetworkDivisions" *ngIf="salesNetworkDivisions && salesNetworkDivisions.controls.length > 0 && sndFields">
      <div class="ui-g ui-fluid" *ngFor="let snd of salesNetworkDivisions.controls; let i=index" [formGroupName]="i">
        <p-panel class="ui-g-12">
          <p-header>
            <div class="ui-helper-clearfix pull-left">
              <h3 class="title">{{ 'catalog.validityDetails' | translate }}</h3>
            </div>
            <div class="ui-helper-clearfix pull-right">
              <button pButton type="button" (click)="confirmCancelValidityDetail(snd.get('id').value, i)" icon="fa fa-times" class="ui-button-danger btnDelete"></button>
            </div>
          </p-header>
          <div class="ui-g ui-fluid">
            <div class="ui-g-12  ui-fluid">
              <!-- Divisione -->
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !sndFields.name_division.nullable}">{{ sndFields.name_division.keyName }}</span>
                <p-autoComplete
                  formControlName="name_division"
                  [suggestions]="divisions"
                  (completeMethod)="searchDivision($event)"
                  (onSelect)="getDivisionStores($event, i, snd)"
                  field="div_sales_name">
                </p-autoComplete>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="snd" [validation]="sndFields.name_division"></app-validation-msg>
              </div>
              <!-- Rete di Vendita -->
              <!-- <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !sndFields.name_store.nullable}">{{ sndFields.name_store.keyName }}</span>
                <p-autoComplete
                  formControlName="name_store"
                  [suggestions]="salesNetworks"
                  (completeMethod)="searchSalesNetwork($event, snd.get('name_division').value.id)"
                  [readonly]="!snd.get('name_division').value.id"
                  field="sales_network_name"
                >
                </p-autoComplete>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="snd" [validation]="sndFields.name_store"></app-validation-msg>
              </div> -->
            </div>
            <div class="ui-g-12 ui-fluid">
              <!-- Data Inizio Prenotazione -->
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !sndFields.dt_start_reservation.nullable}">{{ sndFields.dt_start_reservation.keyName }}</span>
                <app-kv-calendar
                  #reservationDateStartField
                  [inputName]="'dt_start_reservation'"
                  [formData]="snd"
                  [startDateSelector]="true"
                  [endDateInputName]="'dt_end_reservation'"
                  [endDateCalendar]="reservationDateEndField"
                  [defaultDate]="snd.get('dt_start_reservation').value"
                  [defaultValue]="snd.get('dt_start_reservation').value"
                  [minDate]="f.dt_start.value"
                  [maxDate]="f.dt_end.value">
                </app-kv-calendar>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="snd" [validation]="sndFields.dt_start_reservation"></app-validation-msg>
              </div>
              <!-- Data Fine Prenotazione -->
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !sndFields.dt_end_reservation.nullable}">{{ sndFields.dt_end_reservation.keyName }}</span>
                <app-kv-calendar
                  #reservationDateEndField
                  [inputName]="'dt_end_reservation'"
                  [formData]="snd"
                  [endDateSelector]="true"
                  [startDateInputName]="'dt_start_reservation'"
                  [startDateCalendar]="reservationDateStartField"
                  [defaultDate]="snd.get('dt_end_reservation').value"
                  [defaultValue]="snd.get('dt_end_reservation').value"
                  [minDate]="f.dt_start.value"
                  [maxDate]="f.dt_end.value">
                </app-kv-calendar>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="snd" [validation]="sndFields.dt_end_reservation"></app-validation-msg>
              </div>
            </div>
            <div class="ui-g-12 ui-fluid">
              <!-- Accumulatori -->
              <div class="ui-g-12 ui-md-4">
                <span class="label" [ngClass]="{'required': !sndFields.acm_id.nullable}">{{ sndFields.acm_id.keyName }}</span>
                <p-dropdown
                  [options]="accumulators"
                  formControlName="acm_id"
                  [autoWidth]="false"
                  [placeholder]="'catalog.selectAcm' | translate"
                  [disabled]="!snd.get('name_division').value.id">
                  <ng-template let-acm pTemplate="item">
                    <div class="ui-helper-clearfix" style="border-bottom:1px solid #D5D5D5; padding-top: 4px; padding-bottom: 4px;">
                      <div>{{ acm.label }}</div> 
                    </div>
                  </ng-template>
                </p-dropdown>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="snd" [validation]="sndFields.acm_id"></app-validation-msg>
              </div>
              <!-- Codice Promozione -->
              <div class="ui-g-12 ui-md-4" *ngIf="snd.get('off_promo_code').value">
                <span class="label" [ngClass]="{'required': !sndFields.off_promo_code.nullable}">{{ sndFields.off_promo_code.keyName }}</span>
                <input type="text" pInputText class="fieldInput" formControlName="off_promo_code"/>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="snd" [validation]="sndFields.off_promo_code"></app-validation-msg>
              </div>
            </div>
          </div>

          <!-- Aggiungi Negozio/Gruppo -->
          <div class="ui-g">
            <div class="ui-g-11 ui-md-11 ui-lg-11">
              <h3 class="title">{{ 'catalog.addStoreTitle' | translate }}</h3>
            </div>
            <div class="ui-g-12 ui-md-12 ">
              <button
                pButton
                (click)="addStore(snd)"
                icon="fa fa-plus-circle"
                iconPos="right"
                type="button"
                class="k-generic-btn add-store-btn"
                label="{{ 'common.add' | translate }}"
                [disabled]="!snd.get('name_division').value.id">
              </button>
            </div>
          </div>
          <!-- Negozi/Gruppi -->
          <div formArrayName="stores" *ngIf="getSndStores(snd) && storeFields">
            <div class="ui-g ui-fluid" *ngFor="let store of getSndStores(snd); let j=index" [formGroupName]="j">
              <p-panel class="ui-g-12">
                <p-header>
                  <div class="ui-helper-clearfix pull-left">
                    <h3 class="title">{{ 'catalog.details' | translate }}</h3>
                  </div>
                  <div class="ui-helper-clearfix pull-right">
                    <button pButton type="button" (click)="confirmCancelStore(store.get('id').value, getSndStores(snd), j)" icon="fa fa-times" class="ui-button-danger btnDelete"></button>
                  </div>
                </p-header>
                <div class="ui-g ui-fluid">
                  <!-- Tipologia -->
                  <div class="ui-g-12 ui-md-4">
                    <span class="label" [ngClass]="{'required': !storeFields.type_store.nullable}">{{ storeFields.type_store.keyName }}</span>
                    <p-dropdown
                      [options]="typologies"
                      [placeholder]="'catalog.selectType' | translate"
                      formControlName="type_store"
                      [autoWidth]="false">
                    </p-dropdown>
                    <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="store" [validation]="storeFields.type_store"></app-validation-msg>
                  </div>
                  <!-- Negozio -->
                  <div class="ui-g-12 ui-md-4" *ngIf="store.get('type_store').value !== '0'">
                    <span class="label" [ngClass]="{'required': !storeFields.store_id.nullable}">{{ storeFields.store_id.keyName }}</span>
                    <p-dropdown
                      *ngIf="stores[i]['show']"
                      [options]="stores[i]['data']"
                      [placeholder]="'catalog.selectStore' | translate"
                      formControlName="store_id"
                      [autoWidth]="false"
                      [disabled]="store.get('type_store').value === null">
                    </p-dropdown>
                    <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="store" [validation]="storeFields.store_id"></app-validation-msg>
                  </div>
                  <!-- Gruppo di Negozi -->
                  <div class="ui-g-12 ui-md-4" *ngIf="store.get('type_store').value === '0'">
                    <span class="label" [ngClass]="{'required': !storeFields.store_group_id.nullable}">{{ storeFields.store_group_id.keyName }}</span>
                    <p-dropdown
                      *ngIf="storeGroups[i]['show']"
                      [options]="storeGroups[i]['data']"
                      [placeholder]="'catalog.selectGroup' | translate"
                      formControlName="store_group_id"
                      [autoWidth]="false"
                      [disabled]="store.get('type_store').value === null">
                    </p-dropdown>
                    <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="store" [validation]="storeFields.store_group_id"></app-validation-msg>
                  </div>
                  <div class="ui-g-12 ui-md-2"></div>
                  <!-- Flag -->
                  <div class="ui-g-12 ui-md-2">
                    <span class="label" [ngClass]="{'required': !storeFields.flg_type_excl.nullable}">{{ storeFields.flg_type_excl.keyName }}</span>
                    <input id="flag-excl" [placeholder]="'catalog.exclude' | translate" type="text" pInputText class="fieldInput" formControlName="flg_type_excl"/>
                    <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="store" [validation]="storeFields.flg_type_excl"></app-validation-msg>
                  </div>
                </div>
              </p-panel>
            </div>
          </div>
        </p-panel>
      </div>
    </div>

  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog/catalog-detail/catalog-detail.component.html